// extracted by mini-css-extract-plugin
export var message = "NotFoundMessage-module--message--5NFAe";